<template>
  <div class="activityManage">
    <div class="breadcrumb">
      跑步按钮广告
      <el-button class="right_f" type="primary" @click="addRunBtn"
        >新增</el-button
      >
    </div>
    <el-form :inline="true">
      <el-form-item label="活动名称" style="margin-left: 20px;width:280px" >
        <el-input
          placeholder="请输入名称"
          v-model="searchForm.name"
          class="input-small"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="状态" style="width:300px">
        <el-select v-model="searchForm.status" clearable>
          <el-option label="已发布" :value="1"></el-option>
          <el-option label="已撤销" :value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="起止时间:" style="width:480px">
        <el-date-picker
          v-model="searchForm.startTime"
          value-format="yyyy-MM-dd HH:mm:ss"
          type="datetime"
          placeholder="选择开始日期时间"
        >
        </el-date-picker>
        -
        <el-date-picker
          v-model="searchForm.endTime"
          value-format="yyyy-MM-dd HH:mm:ss"
          type="datetime"
          placeholder="选择结束日期时间"
        >
        </el-date-picker>
      </el-form-item>
      <el-button type="primary" @click="getList()">搜索</el-button>
    </el-form>
    <div class="com-list">
      <el-table :data="list" style="overflow-x: auto">
        <el-table-column prop="id" label="ID" align="center" width="80">
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          label="活动名称"
          align="center"
          prop="name"
        >
        </el-table-column>
        <el-table-column inline-template label="按钮图" align="center">
          <img :src="row.imgUrl" alt="" />
        </el-table-column>
        <el-table-column inline-template label="适用学校" align="center">
          <template >
            {{ row.allUnidFlag == 0 ? "全部" : row.allUnidFlag }}
          </template>
        </el-table-column>
        <el-table-column prop="pvcount" label="PV" align="center">
        </el-table-column>
        <el-table-column prop="uvcount" label="UV" align="center">
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          label="起止时间"
          align="center"
          width="200px"
          inline-template
        >
          <template>
            {{ row.startTime }} - {{ row.endTime }}
          </template>
        </el-table-column>
        <el-table-column inline-template show-overflow-tooltip label="最后操作" align="center">
          <template >
            <div>
              {{ row.updateName }}
            </div>
            <div>
              {{ row.updateTime }}
            </div>
          </template>
        </el-table-column>
        <el-table-column inline-template prop="status" label="状态" align="center">
          <template >
            {{
              row.status == 1
                ? "已发布"
                : row.status == 2
                ? "已撤销"
                : ""
            }}
          </template>
        </el-table-column>
        <el-table-column inline-template label="操作" width="180px">
          <template>
            <el-button
              type="primary"
              size="small"
              title="查看"
              @click="navEditor(row.id, 'look')"
              >查看</el-button
            >
            <el-button
              type="warning"
              size="small"
              title="撤销"
              v-if="row.status == 1"
              @click="handleStatus(row.id, 2)"
              >撤销</el-button
            >
            <el-button
              type="info"
              size="small"
              title="编辑"
              v-if="row.status == 2"
              @click="navEditor(row.id)"
              >编辑</el-button
            >
            <el-button
              type="success"
              size="small"
              title="发布"
              v-if="row.status == 2"
              @click="handleStatus(row.id, 1)"
              >发布</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination">
      <el-pagination
        v-show="this.totalCount > 0"
        layout="prev, pager, next, jumper"
        :page-size="20"
        :current-page="currentPage"
        :total="totalCount"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      list: [{ name: "测试名字" }],
      searchForm: {
        startTime: "",
        endTime: "",
      },
      totalCount: 0,
      currentPage: 1,
      /* 底下的等会删了 */
      //   activityStatus: "-1",
      //   options: [],
      //   unid: "-1",
      //   activitys: [],
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    /***
     * 获取活动列表
     ***/
    getList() {
      if (this.searchForm.startTime instanceof Date) {
        this.searchForm.startTime = this.jsDateFormatter(
          this.searchForm.startTime
        );
      }
      if (this.searchForm.endTime instanceof Date) {
        this.searchForm.endTime = this.jsDateFormatter(this.searchForm.endTime);
      }

      console.log(this.searchForm.startTime, this.searchForm.endTime);
      this.$http({
        method: "POST",
        url: this.$util.domain + "/adminapi/v1/operate/button/list",
        body: JSON.stringify({
          pageNum: this.currentPage,
          pageSize: 20,
          ...this.searchForm,
        }),
      })
        .then((result) => {
          console.log("按钮列表List", result);
          if (result.data.error == 10000) {
            this.list = result.data.data;
          }
        })
        .catch((err) => {});
    },
    //撤销发布
    handleStatus(id, status) {
      this.$confirm(
        `此操作将${status == 1 ? "发布" : "撤销"}ID为 ${id} 的活动按钮`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          this.$http({
            method: "POST",
            url: this.$util.domain + "/adminapi/v1/operate/button/updateStatus",
            body: JSON.stringify({
              id,
              status,
            }),
          }).then((res) => {
            console.log("撤销发布", res);
            if (res.data.error == 10000) {
              this.$message({
                type: "success",
                message: `${status == 1 ? "发布" : "撤销"}成功!`,
              });
              this.getList();
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    addRunBtn() {
      this.$router.push("/yunying/advert/addRunBtn");
    },
    //请求分页数据*
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getList();
    },
    //编辑
    navEditor(id, params) {
      this.$router.push({
        path: "/yunying/advert/addRunBtn",
        query: { id, type: params },
      });
    },
    jsDateFormatter(dateInput) {
      // dateInput 是一个 js 的 Date 对象
      var year = dateInput.getFullYear();
      var month = dateInput.getMonth() + 1;
      var theDate = dateInput.getDate();
      var hour = dateInput.getHours();
      var minute = dateInput.getMinutes();
      var second = dateInput.getSeconds();
      if (month < 10) {
        month = "0" + month;
      }
      if (theDate < 10) {
        theDate = "0" + theDate;
      }
      if (hour < 10) {
        hour = "0" + hour;
      }
      if (minute < 10) {
        minute = "0" + minute;
      }

      if (second < 10) {
        second = "0" + second;
      }
      return (
        year +
        "-" +
        month +
        "-" +
        theDate +
        " " +
        hour +
        ":" +
        minute +
        ":" +
        second
      );
    },
  },
};
</script>
<style   scoped>
</style> 


// WEBPACK FOOTER //
// runBtn.vue?6df10a52